import Pikaday from 'pikaday';
import { formatFormData, toggleLoading } from 'helpers/utils';
import { getOrders } from 'helpers/api';
import { updateList } from './order-history';

class List {
    constructor({ target, orderCount }) {
        this.state = {
            target,
            orderCount,
            search: target.getElementsByClassName('js--list-search-container').length
                ? target.getElementsByClassName('js--list-search-container')[0]
                : null,
            pageNumber: 1,
            hidden: 'list-grid__results--hidden',
            dates: [],
            pageGroup: 1,
            pageNum: 1,
            paginationArrowsSet: false,
        };
    }

    // ==================================================
    // HANDLERS
    // ==================================================

    updatePages() {
        const paginationData = this.state.target.getElementsByClassName('js--pagination-data')[0];
        const next = this.state.target.querySelector('.js--pagination-arrow[data-action="next"]');
        const pageLinks = [];

        if (paginationData.classList.contains('js--pagination-rendered')) {
            this.state.pageCount = parseInt(paginationData.getAttribute('data-page-count'), 10);
            this.state.orderCount = parseInt(paginationData.getAttribute('data-page-total'), 10);
            this.setPaginationHandlers();
            return (this.state.paginationArrowsSet = true);
        }

        for (let i = this.state.orderCount; i > 1; i -= 10) {
            const { pageNum } = this.state;
            const active = pageNum === 1 ? 'list-grid__pagination--active' : '';
            pageLinks.push(this.pageHandle(pageNum, active));
            this.state.pageNum += 1;
        }

        if (this.state.orderCount < 11) {
            next.classList.add('list-grid__pagination--disabled');
        } else {
            next.classList.remove('list-grid__pagination--disabled');
        }

        this.state.target.getElementsByClassName('js--pagination-total')[0].innerHTML =
            this.state.orderCount;

        this.state.target.getElementsByClassName('js--pagination-showing')[0].innerHTML = `${
            this.state.orderCount < 1 ? '0' : '1'
        }-${this.state.orderCount > 9 ? '10' : this.state.orderCount}`;

        this.state.target.getElementsByClassName('js--list-pages')[0].innerHTML =
            this.state.pageNum === 1
                ? this.pageHandle(1, 'list-grid__pagination--active')
                : pageLinks.join('');

        paginationData.setAttribute('data-page-count', this.state.pageNum - 1);
        paginationData.setAttribute('data-page-total', this.state.orderCount);
        this.state.pageCount = this.state.pageNum - 1;
        this.setPaginationHandlers();
        this.state.paginationArrowsSet = true;
    }

    toggleSearch() {
        const searchBtn =
            this.state.target.getElementsByClassName('js--list-search-toggle')[0].classList;
        const search = this.state.target.getElementsByClassName('js--list-search-container')[0]
            .classList;

        search.toggle('list-grid__search--hidden');
        ['reset', 'cancel'].forEach((k) =>
            this.toggleOptions(k, !search.contains('list-grid__search--hidden')),
        );

        if (search.contains('list-grid__search--hidden')) {
            this.clearSearchFields();
            searchBtn.add('list-grid__search--hide');

            setTimeout(() => searchBtn.remove('none'), 200);
            return setTimeout(() => searchBtn.remove('list-grid__search--hide'), 210);
        }

        searchBtn.add('none');
    }

    async fetchList(data) {
        if (!data) {
            const res = await getOrders(formatFormData(this.state.search));
            data = res.data.Orders || [];
        }

        this.state = {
            ...this.state,
            pageGroup: 1,
            pageNum: 1,
            orderCount: data.length,
        };

        Array.from(document.getElementsByClassName('js--pagination-arrow')).forEach((k) =>
            k.classList.add('list-grid__pagination--disabled'),
        );

        if (this.state.searchType === 'orderHistory') {
            updateList(data);
        }

        this.updatePages();
    }

    pageHandle(pageNum, active) {
        return `<a href="#" class="js--pagination-page js--pagination-number-${pageNum} list-grid__pagination__link ${active}" data-page="${pageNum}">${pageNum}</a>`;
    }

    clearSearchFields() {
        Array.from(this.state.search.getElementsByClassName('js--list-search-field')).forEach(
            (k) => {
                k.value = '';
            },
        );
    }

    toggleOptions(btn, display = false) {
        const target = this.state.target.getElementsByClassName(`js--list-search-${btn}`)[0]
            .classList;

        return display
            ? target.remove('list-grid__search--hide')
            : target.add('list-grid__search--hide');
    }

    updateArrows(page = 1) {
        const disabled = 'list-grid__pagination--disabled';
        const prevArrow = this.state.target.querySelector(
            '.js--pagination-arrow[data-action="previous"]',
        );
        const nextArrow = this.state.target.querySelector(
            '.js--pagination-arrow[data-action="next"]',
        );

        if (page === 1) {
            prevArrow.classList.add(disabled);
            prevArrow.setAttribute('readonly', 'readonly');
        } else if (page !== 1 && prevArrow.classList.contains(disabled)) {
            prevArrow.classList.remove(disabled);
            prevArrow.removeAttribute('readonly');
        }

        if (page >= this.state.pageCount) {
            nextArrow.classList.add(disabled);
            prevArrow.setAttribute('readonly', 'readonly');
        } else if (page !== this.state.pageCount && nextArrow.classList.contains(disabled)) {
            nextArrow.classList.remove(disabled);
            nextArrow.removeAttribute('readonly');
        }
    }

    updateRange() {
        const start = this.state.pageNumber * 10 - 9;
        const finish = this.state.orderCount <= start + 9 ? this.state.orderCount : start + 9;

        this.state.range.innerHTML = `${start}-${finish}`;
    }

    handleArrowClick(action) {
        const { pageNumber, pageCount } = this.state;
        const requestedPage = action === 'next' ? pageNumber + 1 : pageNumber - 1;

        if (
            (action === 'next' && requestedPage <= pageCount) ||
            (action === 'previous' && requestedPage >= 1)
        ) {
            this.updateView(requestedPage);
        }
    }

    async handleSearchSubmit(e) {
        e.preventDefault();

        const formData = formatFormData(this.state.search);
        toggleLoading(true);
        const res = await getOrders(formData);
        toggleLoading();
        this.fetchList(res.data.Orders || []);
    }

    updateView(page) {
        this.state.target
            .getElementsByClassName('list-grid__pagination--active')[0]
            .classList.remove('list-grid__pagination--active');

        Array.from(
            this.state.target.getElementsByClassName(
                `js--pagination-page-${this.state.pageNumber}`,
            ),
        ).forEach((k) => k.classList.add(this.state.hidden));

        Array.from(this.state.target.getElementsByClassName(`js--pagination-page-${page}`)).forEach(
            (k) => k.classList.remove(this.state.hidden),
        );

        this.state.target
            .getElementsByClassName(`js--pagination-number-${page}`)[0]
            .classList.add('list-grid__pagination--active');

        this.state.pageNumber = page;
        this.updateRange();
        this.updateArrows(page);

        document
            .getElementsByClassName('js--db-content')[0]
            .scrollTo(0, this.state.target.offsetTop - 30);
    }

    setPaginationHandlers() {
        this.state.pageNumber = 1;
        Array.from(this.state.target.getElementsByClassName('js--pagination-page')).forEach((k) =>
            k.addEventListener('click', (e) =>
                this.updateView(parseInt(e.target.getAttribute('data-page'), 10)),
            ),
        );

        Array.from(this.state.target.getElementsByClassName('js--pagination-arrow')).forEach(
            (k) => {
                if (this.state.paginationArrowsSet && k.getAttribute('data-action')) {
                    return;
                }

                k.addEventListener('click', () =>
                    this.handleArrowClick(k.getAttribute('data-action')),
                );
            },
        );
    }

    // ==================================================
    // INITIALIZERS
    // ==================================================

    init() {
        const date = new Date();
        const startDate = new Date();

        startDate.setDate(startDate.getDate() - 14);
        this.updatePages();
        this.state = {
            ...this.state,
            searchType: this.state.search ? this.state.search.getAttribute('data-type') : null,
            range: this.state.target.getElementsByClassName('js--pagination-showing')[0],
        };

        if (this.state.search) {
            ['js--list-search-toggle', 'js--list-search-cancel'].forEach((k) =>
                this.state.target
                    .getElementsByClassName(k)[0]
                    .addEventListener('click', () => this.toggleSearch()),
            );

            this.state.target
                .getElementsByClassName('js--list-search-reset')[0]
                .addEventListener('click', () => this.clearSearchFields());

            this.state.target
                .getElementsByClassName('js--list-search-cancel')[0]
                .addEventListener('click', () => this.fetchList());

            this.state.search
                .getElementsByClassName('js--list-submit')[0]
                .addEventListener('click', (e) => this.handleSearchSubmit(e));
        }

        Array.from(this.state.target.getElementsByClassName('js--list-date')).forEach((k) => {
            this.state.dates.push(
                () =>
                    new Pikaday({
                        field: k,
                        format: 'MM/DD/YYYY',
                        defaultDate: k.name === 'StartDate' ? startDate : date,
                        setDefaultDate: true,
                    }),
            );
        });

        this.state.dates.forEach((k) => k());
    }
}

// ==================================================
// INIT
// ==================================================

function init(props) {
    const arr = [];
    const orderCount = props && props.orderCount ? props.orderCount : 0;
    const init = `js--pagination-list${props && props.start ? '-init' : ''}`;
    console.log('being initted');
    Array.from(document.getElementsByClassName(init)).forEach((k) =>
        arr.push(() => new List({ target: k, orderCount }).init()),
    );
    arr.forEach((k) => k());
}

export default init;
